export default "__VITE_ASSET__a6df7cd1__"